import { Component } from '@angular/core';

import { ProgressBarService } from '../progress-bar.service';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared.module';
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    standalone: true,
    imports: [
        CommonModule,
        SharedModule,
    ],
    styleUrls: ['./progress-bar.component.scss'],
})
export class ProgressBarComponent {

    private readonly _progressBarService = injectRequired(ProgressBarService);

    // Zichtbaarheid + timing (show-delay/hide-grace) leven in de root-ProgressBarService: elke pagina
    // heeft een eigen footer en dus een eigen instantie, die zo meteen de lopende stand overneemt i.p.v.
    // bij elke navigatie weer onzichtbaar te beginnen. Signal, zodat de view ook binnen OnPush-pagina's
    // (SinglePage/TabPage) vanzelf ververst.
    showProgressBar$$ = this._progressBarService.visible$$;
    mode$ = this._progressBarService.mode$;
    value$ = this._progressBarService.progressValue$;
}
